import * as Yup from 'yup';
import { validationSchema as addressValidationSchema } from 'components/Form/AddressFormComponent';

const validationSchema = Yup.object({
	name: Yup.string().required('pages.customers.nameRequired'),
	telephone: Yup.string().required('pages.customers.phoneRequired'),
	addresses: Yup.array().of( addressValidationSchema ),
});

export default validationSchema;